/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Typography, Divider, Button } from '@mui/material';
import './CardfordownloadEditViewAction/CardfordownloadEditViewAction.css';
import { fonts, themes } from '../themes/themes';

interface contentTileType {
  tile_value: string;
  subtitle1: string;
  assetId: any;
  subtitle2: string;
  assetType: string;
  subtitle3: string;
  assignedDate: any;
  returnedtitle: string;
  returnedDate: any;
  subtitle4: string;
  remarks: string;
  trans?: any;
}
const ReturnedAssetListBox: React.FC<contentTileType> = ({
  tile_value,
  subtitle1,
  assetId,
  subtitle2,
  assetType,
  subtitle3,
  assignedDate,
  returnedtitle,
  returnedDate,
  subtitle4,
  remarks,
  trans,
}) => {
  return (
    <Grid
      container
      style={{
        marginTop: '12px',
        width: 'auto',
        height: 'auto',
        paddingLeft: '23px',
        paddingRight: '23px',
        paddingTop: '10px',
        paddingBottom: '10px',
        backgroundColor: '#fafafa',
        borderRadius: '6px',
        opacity: 1,
      }}
    >
      <Grid item style={{ flexGrow: 1 }}>
        <Typography className="title1" sx={{ fontSize: '1em' }}>
          {tile_value}
        </Typography>
        <Grid container>
          <Grid item>
            <Typography className="subtitle1" sx={{ fontSize: '0.75em' }}>
              {subtitle1} :
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="mx-1 identifierNo"
              sx={{
                fontSize: '0.75em',
              }}
            >
              {assetId}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item>
            <Typography className="subtitle1" sx={{ fontSize: '0.75em' }}>
              {subtitle2} :
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="mx-1 identifierNo"
              sx={{
                fontSize: '0.75em',
              }}
            >
              {assetType}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item>
            <Typography className="subtitle1" sx={{ fontSize: '0.75em' }}>
              {subtitle3} :
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="identifierNo"
              sx={{
                fontSize: '0.75em',
              }}
            >
              {assignedDate}
            </Typography>
          </Grid>
          <Grid item>
            <Divider orientation="vertical" className="mx-1" />
          </Grid>
          <Grid item style={{ marginTop: '0.08em' }}>
            <Typography
              className="Issuetitle"
              sx={{
                marginLeft: '0.5em',
                fontSize: '0.75em',
                color: themes.red,
              }}
            >
              {returnedtitle}:
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className="expdate"
              sx={{
                color: themes.red,
                fontSize: '0.8em',
                marginLeft: '0.2em',
              }}
            >
              {returnedDate}
            </Typography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item>
            <Typography className="subtitle1" sx={{ fontSize: '0.75em' }}>
              {subtitle4} :
            </Typography>
          </Grid>
          <Grid item style={{ marginLeft: '0.2em' }}>
            <Typography
              className="mx-1 identifierNo"
              sx={{
                fontSize: '0.75em',
              }}
            >
              {remarks}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item style={{ marginTop: '1.9em' }}>
        <Button
          style={{
            fontFamily: fonts.fontFamily,
            fontSize: fonts.subtitle,
            color: themes.red,
            border: '1px solid #F44336',
          }}
        >
          {trans('Returned')}
        </Button>
      </Grid>
    </Grid>
  );
};
export default ReturnedAssetListBox;
